import { Head, Form as InertiaForm, Link } from "@inertiajs/react";
import AuthLayout from "@/layout/AuthLayout.tsx";
import { Button } from "@/components/ui/button.tsx";
import { Input } from "@/components/ui/input.tsx";
import { Label } from "@/components/ui/label.tsx";

type PasswordEditProps = {
  reset_password_token: string;
  minimum_password_length?: number;
};

const Edit = ({ reset_password_token, minimum_password_length }: PasswordEditProps) => {
  return (
    <>
      <Head title="Nouveau mot de passe" />
      <div className="space-y-6">
        <div className="space-y-2">
          <p className="text-xs uppercase tracking-[0.35em] text-muted-foreground">Securite</p>
          <h1 className="text-3xl font-semibold">Definir un nouveau mot de passe</h1>
          <p className="text-sm text-muted-foreground">
            Utilisez un mot de passe robuste pour proteger votre compte.
          </p>
        </div>

        <InertiaForm
          method="put"
          action="/users/password"
          transform={(data) => ({ user: data })}
          className="space-y-4"
        >
          {({ errors, processing }) => (
            <>
              <input type="hidden" name="reset_password_token" value={reset_password_token} />

              <div className="space-y-2">
                <Label htmlFor="password">Nouveau mot de passe</Label>
                <Input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="new-password"
                  required
                />
                {minimum_password_length && (
                  <p className="text-xs text-muted-foreground">
                    Minimum {minimum_password_length} caracteres.
                  </p>
                )}
                {errors.password && (
                  <p className="text-xs text-red-500">{errors.password.join(", ")}</p>
                )}
              </div>

              <div className="space-y-2">
                <Label htmlFor="password_confirmation">Confirmation</Label>
                <Input
                  id="password_confirmation"
                  name="password_confirmation"
                  type="password"
                  autoComplete="new-password"
                  required
                />
                {errors.password_confirmation && (
                  <p className="text-xs text-red-500">
                    {errors.password_confirmation.join(", ")}
                  </p>
                )}
              </div>

              <Button type="submit" className="w-full" disabled={processing}>
                {processing ? "Mise a jour..." : "Mettre a jour"}
              </Button>
            </>
          )}
        </InertiaForm>

        <div className="text-sm text-muted-foreground">
          <Link href="/users/sign_in" className="text-primary hover:underline">
            Retour a la connexion
          </Link>
        </div>
      </div>
    </>
  );
};

Edit.layout = (page: React.ReactNode) => <AuthLayout>{page}</AuthLayout>;

export default Edit;
